<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 12,0.75c6.213,0,11.25,5.037,11.25,11.25S18.213,23.25,12,23.25S0.75,18.213,0.75,12S5.787,0.75,12,0.75z "
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 12,3.685c4.592,0,8.315,3.723,8.315,8.315S16.592,20.315,12,20.315S3.685,16.592,3.685,12S7.408,3.685,12,3.685z "
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 12.576,6.97 l1.254,2.584h2.441c0.331-0.012,0.609,0.247,0.621,0.579c0.006,0.178-0.067,0.349-0.199,0.467l-2.119,2.214l1.174,2.7 c0.135,0.327-0.02,0.701-0.346,0.836c-0.183,0.076-0.392,0.063-0.564-0.036L12,14.717l-2.837,1.6 c-0.306,0.177-0.698,0.072-0.874-0.234c-0.1-0.173-0.113-0.382-0.037-0.566l1.174-2.7L7.308,10.6 c-0.246-0.221-0.267-0.601-0.045-0.847c0.118-0.131,0.288-0.204,0.464-0.199h2.441l1.257-2.584 c0.164-0.318,0.555-0.442,0.873-0.278C12.417,6.754,12.514,6.851,12.576,6.97z"
      stroke="currentColor"
      fill="none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
export default {
  name: "IconQuests",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>
